@if (viewsStateService.boxViews || viewsStateService.workflowViews) {
    <form class="views-container">
        <mat-form-field class="without-error">
            <mat-label>Vue</mat-label>
            <mat-select (selectionChange)="viewChange($event)" [value]="selectedView?.id" panelClass="views-container-panel">
                @if (viewsStateService.boxViews.length !== 0) {
                    <mat-optgroup label="Bannettes">
                        @for (view of viewsStateService.boxViews; track view.id) {
                            <mat-option [value]="view.id">{{ view.name }}</mat-option>
                        }
                    </mat-optgroup>
                }
                @if (viewsStateService.workflowViews.length !== 0) {
                    <mat-optgroup label="Workflows">
                        @for (view of viewsStateService.workflowViews; track view.id) {
                            <mat-option [value]="view.id">{{ view.name }}</mat-option>
                        }
                    </mat-optgroup>
                }
                @if (viewsStateService.archivingViews.length !== 0) {
                    <mat-optgroup label="Archives">
                        @for (view of viewsStateService.archivingViews; track view.id) {
                            <mat-option [value]="view.id">{{ view.name }}</mat-option>
                        }
                    </mat-optgroup>
                }
            </mat-select>
        </mat-form-field>
    </form>
}
